import { Injectable } from '@angular/core';
import { ILookupValue } from '../models/lookupvalues';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  compareValues(value1: ILookupValue, value2: ILookupValue): boolean {
    return value1 && value2 ? value1.Key === value2.Key && value1.Id === value2.Id && value1.Value === value2.Value
      : value1 === value2;
  }
  displayValue(value: ILookupValue): string {
    return value ? value.Value : null;
  }
}
